<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="modal-container"
      @click.self.prevent="$emit('close')"
    >
      <div class="modal">
        <button
          aria-label="close"
          class="absolute top-0 right-0 text-xl text-gray-500 my-2 mx-4"
          @click.prevent="$emit('close')"
        >
          ×
        </button>
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    showing: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector('body').classList.add('overflow-hidden');
      }

      document.querySelector('body').classList.remove('overflow-hidden');
    },
  },
};
</script>
